export default __webpack_public_path__ + "static/media/Izmir-Extralight.51c90050.woff2";